<form [formGroup]="sbBerekeningFg">
    <div class="pb-1">
        <div class="row">
            <div class="col col-1 bold">
                Bedrag van de schenking
            </div>
            <div class="col-2 bold">

            </div>
            <div class="col-2 bold">

            </div>
        </div>
    </div>
    <div *ngIf="this.hasContanten">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde contanten</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaalBedragContanten"
                                                  class="custom-input-150 custom-readonly"
                                                  align="right"
                                                  prefix="€"
                                                  [showAllDecimals]="false"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasEffecten">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde effecten</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaalBedragEffecten"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasOnroerendeZaken">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde onroerende zaken</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaleWaardeGeschonkenOnroerendeZaken"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasRoerendeZaken">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde roerende zaken</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleWaardeGeschonkenRoerendeZaken"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasPU">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde periodieke uitkeringen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleWaardeGeschonkenPu"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasSchuldigerkenning">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde schenkingen op papier</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleWaardeSchuldigErkenning"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasKwijtschelding">
        <div class="row">
            <div class="col col-1">
                <p>Totaal kwijtgescholden vorderingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleWaardeKwijtscheldingen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasVruchtgebruiken">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde vruchtgebruik</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleWaardeVruchtgebruik"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasOverige">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde overige schenkingen</p>
            </div>
            <div class="col-2">

            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaleWaardeOverigeSchenkingen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.hasOnderneming">
        <div class="row">
            <div class="col col-1">
                <p>Totale waarde ondernemingsvermogen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaalGeschonkenOndernemingsVermogen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Totaal van de schenking</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaleSchenking"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div class="pb-1">
        <div class="row">
            <div class="col col-1 bold">
                Vrijstellingen
            </div>
            <div class="col-2 bold">
            </div>
            <div class="col-2 bold">
            </div>
        </div>
    </div>
    <div *ngIf="this.hasOnderneming">
        <div class="row">
            <div class="col col-1">
                <p>Bedrijfsopvolgingsvrijstelling</p>
            </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control formControlName="totaalVrijgesteldOndernemingsVermogen"
                                                      class="custom-input-150 custom-readonly"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      prefix="€ -"
                    >
                    </snelstart-ui-number-form-control>
                </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Overige vrijstellingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="totaleVrijstellingen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Al benutte overige vrijstellingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="eerderGebruikteVrijstellingen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Toegepaste overige vrijstelling</p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="benutteVrijstellingen"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div class="pb-1">
        <div class="row">
            <div class="col col-1">
                <p><b>Belaste schenking</b></p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="totaleBelastbareSchenking"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.sbBerekening.grondslagConserverendeAanslag != null">
        <div class="row">
            <div class="col col-1">
                <p>Waarvan vastgesteld in conserverende aanslag</p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
                <snelstart-ui-number-form-control formControlName="grondslagConserverendeAanslag"
                                                  class="custom-input-150 custom-readonly"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>

<div *ngIf="this.aantalValidatiesValue !== 0 && this.aantalValidatiesValue !== 451" style="width: 75%">

    <snelstart-ui-alert type="warning" class="pb-2 pt-2 ps-2 pe-2">
        Er zijn nog validatiemeldingen. <b></b> Klik op de button 'Validaties' in het menu en bekijk om
        welke validaties het gaat.<br/>
        Pas dan de gegevens aan zodat alle validatiemeldingen verdwijnen. Daarna wordt hier de berekening getoond.
    </snelstart-ui-alert>
</div>
